
import certificate from '@/pages/Certificate/index'
export default [
	{
		name: 'certificate',
		path: '/certificate',
		component: certificate
	}
]
